import React from 'react';

export default ({ children }) => {
    return (
        <html style={{ paddingTop: '50px', paddingBottom: '50px' }}>
            <body>{children}</body>
        </html>
    );
};
